import { createSlice } from '@reduxjs/toolkit'

export type CashBreakRedux = {
  advancedSettings: CashBreakAdvancedSettings
}

export interface CashBreakAdvancedSettings {
  unmatchedExtTransactions: boolean
  ignoredExtTransactions: boolean
  unmatchedUnclearedCwTx: boolean
  clearedCashTransactions: boolean
  clearedMmfTrades: boolean
  preserveNonDefaultSettings: boolean
}

export const defaultAdvancedSettings: CashBreakAdvancedSettings = {
  unmatchedExtTransactions: false,
  ignoredExtTransactions: false,
  unmatchedUnclearedCwTx: false,
  clearedCashTransactions: false,
  clearedMmfTrades: false,
  preserveNonDefaultSettings: false,
}

export const CashBreakInitialState: CashBreakRedux = {
  advancedSettings: defaultAdvancedSettings,
}

export const cashBreakSlice = createSlice({
  name: 'CashBreak',
  initialState: CashBreakInitialState,
  reducers: {
    setAdvancedSettings: (oldState, action) => ({
      ...oldState,
      advancedSettings: action.payload,
    }),
    clearAdvancedSettings: oldState => ({
      ...oldState,
      advancedSettings: defaultAdvancedSettings,
    }),
  },
})

export const { setAdvancedSettings, clearAdvancedSettings } =
  cashBreakSlice.actions

export default cashBreakSlice.reducer
